<template>

   <v-flex xs12 sm12 md10 lg8 offset-md1 offset-lg2>

        <div class="text-xs-center loginbar-group">

            <div class="btn-group" style="width: 100%">

              <v-btn color="primary" class="button loginbarBtn" style="width: 50%" @click.prevent='$router.push({name: "Register"})'>

                    {{  $t( 'user_management.register' ) }}

                </v-btn>

                <v-btn color="success" class="button loginbarBtn" style="width: 50%" @click.prevent='$router.push({name: "login"})'>

                    {{  $t( 'user_management.login' ) }}

                </v-btn>

            </div>

        </div>

    </v-flex>

</template>

<script>
export default {
    data() {
        return {
            //
        }
    }
}
</script>

<style scope>

.btn-group button {
  cursor: pointer; /* Pointer/hand icon */
  float: left; /* Float the buttons side by side */
}

/* Clear floats (clearfix hack) */
.btn-group:after {
  content: "";
  clear: both;
  display: table;
}

.btn-group button:not(:last-child) {
  border-right: none; /* Prevent double borders */
}

.loginbarBtn {
    margin: 0;
    border-radius: 0px;
}

</style>